import * as React from "react"
import { cn } from "@/lib/utils"

export function Badge({ className, ...props }: React.HTMLAttributes<HTMLSpanElement>) {
  return <span className={cn("inline-flex items-center gap-1.5 rounded-full border border-current/15 bg-current/5 px-3 py-1 text-[11px] font-semibold uppercase tracking-[.15em]", className)} {...props} />
}
